
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import t from "@common/src/i18n/t";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";

const staff = namespace("staff");
const user = namespace("user");
const testingItem = namespace("testing-item");
@Component({
  components: { TableEnableFlag, SwitchStatus }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("setting.select-test-item"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class Staff extends Vue {
  @staff.Action getStaffList;
  @staff.Action updateStaffAccountStatus;
  @user.State userData;
  @testingItem.Action updateItemsStatus;
  t = t;
  data = {};
  searchForm = {
    staffName: "",
    mobile: ""
  };
  staffList: any[] = [
    {
      roleList: []
    }
  ];
  searchList: any[] = [
    {
      label: "staff.staff-name",
      type: "input",
      value: "",
      prop: "staffName"
    },
    {
      label: "staff.staff-phone",
      type: "input",
      value: "",
      prop: "mobile"
    },
    {
      label: "setting.mailbox",
      type: "input",
      value: "",
      prop: "email"
    }
  ];

  tableLoading: boolean = false;
  created() {
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getStaffList({
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      ...this.searchForm,
      status: "9"
    }).then(data => {
      this.staffList = data.data.list;
      return data;
    });
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  handleEdit(staff) {
    this.$router.push(`/setting/staff-edit/${staff.userCode}`);
  }
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status, selectedRow) {
    return this.updateStaffAccountStatus({
      status: status,
      userCodeSet: selectedRow ? [selectedRow.userCode] : this.mix_selectedRows.map(item => item.userCode)
    }).then(() => {
      this.$message.success(status ? t("setting.enable-successful") : t("setting.disable-success"));
      this.loadListData();
    });
  }
}
